// TODO: a bit different here file type or file extension...
// Eg. 'image/png' VS '.png'
export const SUPPORTED_FILE_TYPES = ['pdf', 'jpg', 'jpeg', 'png', 'bmp', 'tiff']

export function isSupportedFileType(type = ''): boolean {
  return SUPPORTED_FILE_TYPES.some((substring) => type.includes(substring))
}
